module.exports = __webpack_public_path__ + "images/marketing/accelerate-sales-logo.png";